// =============================
// Imports
// =============================

import { required } from '../index';

// =============================
// Validator
// =============================

const validator = {
  title: required,
  attachment_name: required,
};

export default validator;
